import { CheckboxGroupField, Heading } from '@nbirl/nbi-common-ui-libs';

import { Role } from '../../../shared/enum';
import { Folder } from '../../resources/folders/models';

type FolderManagemntProps = {
  folders: Folder[];
  disabledFolders?: Folder[];
  chosenRole: Role;
  className?: string;
};

export const FolderManagement = ({
  className,
  folders,
  chosenRole,
  disabledFolders,
}: FolderManagemntProps) => {
  const getCheckboxes = () => {
    return folders.map((folder) => ({
      value: folder.id,
      label: folder.name,
      disabled: disabledFolders?.some(
        (disabledFolder) => disabledFolder.id === folder.id
      ),
    }));
  };

  return (
    <div className={className}>
      <Heading size="md" className="mb-8">
        Folder Access
      </Heading>
      {chosenRole === Role.FullAdmin ? (
        <p className="mt-2">Access to all folders</p>
      ) : (
        <CheckboxGroupField label="" name="folderIds" items={getCheckboxes()} />
      )}
    </div>
  );
};
